import React from "react";

import HeaderBanner from "./headerBanner";
import { css, StyleSheet } from "aphrodite";

class PageHeaderBanner extends HeaderBanner {
  constructor(props) {
    super(props);
  }

  render() {
    const { pageLogo, pageSubheader, pageText } = this.props;
    return (
      <section
        style={{
          backgroundColor: this.props.bgColor ? this.props.bgColor : "#BDB5B2",
          color: this.props.textColor ? this.props.textColor : "white",
          textAlign: "center"
        }}
      >
        <div className="container">
          <div className={`row ${css(styles.bannerStyle)}`}>
            <div className={"col-12"}>
              <div className={"pt-md-5"}>
                <img
                  src={pageLogo}
                  className={"pt-5 pb-4 text-right"}
                  alt={"Image not yet available"}
                />
                <h1 className={"pt-4 pb-4"}>{pageSubheader}</h1>
                {pageText}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PageHeaderBanner;

const styles = StyleSheet.create({
  bannerStyle: {
    minHeight: "450px",
    color: "#0c0c0c",
    marginRight: "-25px!important",
    marginLeft: "-25px!important"
  },
  fontStyle: {
    fontWeight: "normal"
  }
});



// WEBPACK FOOTER //
// ./src/sections/layouts/pageHeaderBanner.js